import defaultClient from '@src/api/clients/default';

export function fetchClientZipMap(params = {}) {
  return defaultClient.request({
    url: 'dashboard/client-zip-map/',
    method: 'GET',
    payload: params
  });
}
